function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("title", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2",
  id: "Layer_2"
}, React.createElement("path", {
  d: "M16,29A13,13,0,1,1,29,16,13,13,0,0,1,16,29ZM16,5A11,11,0,1,0,27,16,11,11,0,0,0,16,5Z"
}), React.createElement("path", {
  d: "M16,23a1,1,0,0,1-1-1V10a1,1,0,0,1,2,0V22A1,1,0,0,1,16,23Z"
}), React.createElement("path", {
  d: "M22,17H10a1,1,0,0,1,0-2H22a1,1,0,0,1,0,2Z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "cls-1"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/expand-icon.ceeeb890.svg";
export { SvgComponent as ReactComponent };